import { render, staticRenderFns } from "./Facet.vue.html?vue&type=template&id=39b4d4b5&"
import script from "./Facet.component.js?vue&type=script&lang=vueJs&"
export * from "./Facet.component.js?vue&type=script&lang=vueJs&"
import style0 from "./Facet.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports